// Story BP-8: container principal /admin/billing.
// Tabs (Needs Attention default + All Users + Telemetria) + drawer de override.

import React, { useState, useCallback } from 'react';
import { Gauge } from 'lucide-react';
import { AdminBillingTabs } from './AdminBillingTabs';
import { AdminBillingOverrideDrawer } from './AdminBillingOverrideDrawer';
import type { AdminBillingUser } from '../../hooks/useAdminBilling';

export const AdminBillingPanel: React.FC = () => {
  const [drawerUser, setDrawerUser] = useState<AdminBillingUser | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenOverride = useCallback((user: AdminBillingUser) => {
    setDrawerUser(user);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setDrawerUser(null);
  }, []);

  const handleOverrideSuccess = useCallback(() => {
    setRefreshKey(k => k + 1);
  }, []);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary-500/10 border border-primary-500/20 flex items-center justify-center">
          <Gauge className="w-5 h-5 text-primary-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">Plans &amp; Billing</h1>
          <p className="text-sm text-neutral-400">
            Overrides manuais de plano + grandfather, audit log e telemetria de upgrade intent.
          </p>
        </div>
      </div>

      <AdminBillingTabs onOpenOverride={handleOpenOverride} refreshKey={refreshKey} />

      <AdminBillingOverrideDrawer
        isOpen={drawerUser !== null}
        onClose={handleCloseDrawer}
        user={drawerUser}
        onSuccess={handleOverrideSuccess}
      />
    </div>
  );
};
